function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
// import { Box2dModel, box2dModelValidator } from '../misc/geometry-types'
import { idValidator } from "../misc/id-validator";
// import { cursorTypeValidator, TLCursor } from '../misc/TLCursor'
// import { scribbleValidator, TLScribble } from '../misc/TLScribble'
import { box2dModelValidator } from "../misc";
import { cursorTypeValidator } from "../misc/TLCursor";
import { scribbleValidator } from "../misc/TLScribble";
import { SWINSTANCE_ID } from "./SWInstance";
/** @internal */ export const instancePresenceValidator = T.model("instance_presence", T.object({
    typeName: T.literal("instance_presence"),
    id: idValidator("instance_presence"),
    userId: T.string,
    userName: T.string,
    lastActivityTimestamp: T.number,
    followingUserId: T.string.nullable(),
    cursor: T.object({
        x: T.number,
        y: T.number,
        type: cursorTypeValidator,
        rotation: T.number
    }),
    color: T.string,
    camera: T.object({
        x: T.number,
        y: T.number,
        z: T.number
    }),
    screenBounds: box2dModelValidator,
    selectedShapeIds: T.arrayOf(idValidator("shape")),
    currentPageId: idValidator("page"),
    brush: box2dModelValidator.nullable(),
    scribbles: T.arrayOf(scribbleValidator),
    chatMessage: T.string,
    meta: T.jsonValue
}));
/** @internal */ export const instancePresenceVersions = {
    AddScribbleDelay: 1,
    RemoveInstanceId: 2,
    AddChatMessage: 3,
    AddMeta: 4,
    RenameSelectedShapeIds: 5
};
export const instancePresenceMigrations = defineMigrations({
    currentVersion: instancePresenceVersions.RenameSelectedShapeIds,
    migrators: {
        [instancePresenceVersions.AddScribbleDelay]: {
            up: (instance)=>{
                if (instance.scribble !== null) {
                    return _object_spread_props(_object_spread({}, instance), {
                        scribble: _object_spread_props(_object_spread({}, instance.scribble), {
                            delay: 0
                        })
                    });
                }
                return _object_spread({}, instance);
            },
            down: (instance)=>{
                if (instance.scribble !== null) {
                    const _instance_scribble = instance.scribble, { delay: _delay } = _instance_scribble, rest = _object_without_properties(_instance_scribble, [
                        "delay"
                    ]);
                    return _object_spread_props(_object_spread({}, instance), {
                        scribble: rest
                    });
                }
                return _object_spread({}, instance);
            }
        },
        [instancePresenceVersions.RemoveInstanceId]: {
            up: (_param)=>{
                var { instanceId: _ } = _param, instance = _object_without_properties(_param, [
                    "instanceId"
                ]);
                return instance;
            },
            down: (instance)=>{
                return _object_spread_props(_object_spread({}, instance), {
                    instanceId: SWINSTANCE_ID
                });
            }
        },
        [instancePresenceVersions.AddChatMessage]: {
            up: (instance)=>{
                return _object_spread_props(_object_spread({}, instance), {
                    chatMessage: ""
                });
            },
            down: (_param)=>{
                var { chatMessage: _ } = _param, instance = _object_without_properties(_param, [
                    "chatMessage"
                ]);
                return instance;
            }
        },
        [instancePresenceVersions.AddMeta]: {
            up: (record)=>{
                return _object_spread_props(_object_spread({}, record), {
                    meta: {}
                });
            },
            down: (_param)=>{
                var { meta: _ } = _param, record = _object_without_properties(_param, [
                    "meta"
                ]);
                return _object_spread({}, record);
            }
        },
        [instancePresenceVersions.RenameSelectedShapeIds]: {
            up: (record)=>{
                const { selectedShapeIds } = record, rest = _object_without_properties(record, [
                    "selectedShapeIds"
                ]);
                return _object_spread({
                    selectedShapeIds: selectedShapeIds
                }, rest);
            },
            down: (record)=>{
                const { selectedShapeIds } = record, rest = _object_without_properties(record, [
                    "selectedShapeIds"
                ]);
                return _object_spread({
                    selectedShapeIds: selectedShapeIds
                }, rest);
            }
        }
    }
});
/** @public */ export const InstancePresenceRecordType = createRecordType("instance_presence", {
    migrations: instancePresenceMigrations,
    validator: instancePresenceValidator,
    scope: "presence"
}).withDefaultProperties(()=>({
        lastActivityTimestamp: 0,
        followingUserId: null,
        color: "#FF0000",
        camera: {
            x: 0,
            y: 0,
            z: 1
        },
        cursor: {
            x: 0,
            y: 0,
            type: "default",
            rotation: 0
        },
        screenBounds: {
            x: 0,
            y: 0,
            w: 1,
            h: 1
        },
        selectedShapeIds: [],
        brush: null,
        scribbles: [],
        chatMessage: "",
        meta: {}
    }));
